import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const poland: MarketConfiguration = {
  code: MarketEnum.pl,
  label: "Poland",
  descriptiveLabel: "Polish",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Poland",
  locale: LocaleEnum.pl,
  serviceLocale: ServiceLocaleEnum.pl,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-pl",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.pl,
  adyenMarket: MarketEnum.pl,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default poland;
